import { ColorEnum } from '@/constants/color'
import Heading from '@/features/common/components/Overview/parts/Heading'
import Prices from '@/features/common/components/Overview/parts/Prices'
import { PriceItem } from '@/features/common/components/Overview/types'
import { FC, ReactNode } from 'react'
import { StyleSheet, View } from 'react-native'

interface OverviewProps {
    itemList: ReactNode
    priceItems: PriceItem[]
    totalPrice: string
}

const Overview: FC<OverviewProps> = ({ itemList, priceItems, totalPrice }) => {
    return (
        <View style={styles.container}>
            <Heading />
            <View style={styles.itemListContainer}>{itemList}</View>
            <Prices items={priceItems} totalPrice={totalPrice} />
        </View>
    )
}

const styles = StyleSheet.create({
    container: {
        paddingHorizontal: 16,
        alignSelf: 'stretch',
        backgroundColor: ColorEnum.WHITE,
        gap: 8,
    },
    itemListContainer: {
        gap: 8,
    },
})

export default Overview
